import { StoreService } from './../../shared/store.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ProfileDetails } from '../../shared/models/my-Profile.model';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

const BACKEND_URL = environment.apiUrl + "/user/";
const BACKEND_URL1 = environment.apiUrl + "/backblaze"
@Injectable({
  providedIn: 'root'
})
export class MyprofileService {

  private myProfileView: ProfileDetails[] = [];
  private myProfileUpdated = new Subject<{ myProfileView: ProfileDetails[]; }>();

  constructor(private http: HttpClient, private storeService: StoreService, private route: ActivatedRoute, private router: Router) { }

  updateMyprofileDetails(ProfileView: any, Ref_FileId: string) {
    const userId = localStorage.getItem("userId");
    let myProfiledata;
    if (Ref_FileId == null) {
      myProfiledata = new FormData();
      myProfiledata.append("emailid", ProfileView.emailid);
      myProfiledata.append("Age", ProfileView.Age);
      myProfiledata.append("Gender", ProfileView.Gender);
      myProfiledata.append("Distance", ProfileView.Distance);
      myProfiledata.append("income", ProfileView.income);
      myProfiledata.append("ZIPCode", ProfileView.ZIPCode);
      myProfiledata.append("Country", ProfileView.Country);
      myProfiledata.append("State", ProfileView.State);
    }

    else {
      myProfiledata = new FormData();
      myProfiledata.append("emailid", ProfileView.emailid);
      myProfiledata.append("Age", ProfileView.Age);
      myProfiledata.append("Gender", ProfileView.Gender);
      myProfiledata.append("Distance", ProfileView.Distance);
      myProfiledata.append("income", ProfileView.income);
      myProfiledata.append("ZIPCode", ProfileView.ZIPCode);
      myProfiledata.append("Country", ProfileView.Country);
      myProfiledata.append("State", ProfileView.State);
      myProfiledata.append("Ref_FileId", Ref_FileId);
    }

    this.http.put<{ message: string, profileData: ProfileDetails }>(
      BACKEND_URL + "profile/" + userId,
      myProfiledata
    ).subscribe(profileData => {
      const updateDProfile = [...this.myProfileView];
      const oldProfileIndex = updateDProfile.findIndex(p => p.id === userId);
      const myprofileD: ProfileDetails = {
        emailid: ProfileView.emailid,
        id: userId,
        Age: ProfileView.Age,
        Gender: ProfileView.Gender,
        Distance: ProfileView.Distance,
        income: ProfileView.income,
        ZIPCode: ProfileView.ZIPCode,
        Country: ProfileView.Country,
        State: ProfileView.State,
      };
      updateDProfile[oldProfileIndex] = myprofileD;
      this.myProfileView = updateDProfile;
      this.myProfileUpdated.next({
        myProfileView: [...this.myProfileView]
      })
      // console.log("you have added profile details")

      this.storeService.markProfileUpdate(true);
    });


  }
  getmyProfileData() {
    const userId = localStorage.getItem("userId");
    return this.http.get<{ message: string, Profile: any, Ref_FileId: string, SigningWay: string, Picture: string }>(
      BACKEND_URL + userId)
      .pipe(
        map(profileData => {
          // console.log(profileData)
          if (profileData.Ref_FileId != "undefined") {
            profileData.Ref_FileId = profileData.Ref_FileId
          }
          else {
            profileData.Ref_FileId = null;
          }
          return {
            Ref_FileId: profileData.Ref_FileId,
            myProfileView: profileData.Profile.map(profileD => {
              // if (profileD.imagePath != undefined) {
              // }
              // else { profileD.imagePath = "assets/images/big/icon-user-default.png" }

              if (profileD.Distance != undefined) {
              }
              else { profileD.Distance = "Mile" }
              return {
                id: profileD.id,
                emailid: profileD.emailid,
                Age: profileD.Age,
                Gender: profileD.Gender,
                // Currency: profileD.Currency,
                Distance: profileD.Distance,
                income: profileD.income,
                ZIPCode: profileD.ZIPCode,
                Country: profileD.Country,
                State: profileD.State,
                SigningWay:profileD.SigningWay,
                Picture:profileD.Picture
                // imagePath: profileD.imagePath


              }
            })
          }
        })
      )

  }
  saveImageToBackBlaze(path, fileName) {
    const propertyId = localStorage.getItem("propertyId");
    if (Image == null) {
      return
    }
    else {
      const profileImageData = new FormData();
      profileImageData.append("UserId", localStorage.getItem("userId"));
      profileImageData.append("FilePath", path);
      profileImageData.append("Type", "Profile");
      profileImageData.append("FileDescription", "rentblazr_" + fileName);
      profileImageData.append("FileName", fileName);
      const userId = localStorage.getItem("userId");

      return this.http.post<{ message: string, Response: JSON, code: string }>(
        BACKEND_URL1 + "/uploadFile",
        profileImageData, {
        params: {
          UserId: userId,
          PropertyId: ""
        }
      }
      )
    }

  }
  getmyProfileImageData(Ref_FileId: string) {
    // const userId = localStorage.getItem("userId");
    return this.http.get<{ message: string, Response: JSON, code: string }>(
      BACKEND_URL1 + "/getFile", {
      params: {
        fileId: Ref_FileId
      }
    })
  }
  updatedata(profile) {
    this.myProfileView = profile;
    this.myProfileUpdated.next({
      myProfileView: [...this.myProfileView]
    })

  }
  getProfileUpdatedViewListner() {
    return this.myProfileUpdated.asObservable();
  }
  // getProfileEdit(userId){
  //   return this.myProfileView.filter(profile => profile.id == userId);

  // }
}
